import React, { useState } from 'react';

const WaIco = () => (
  <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.787" />
  </svg>
);

export default function WaSendModal({ isOpen, onClose, imageDataUrl }) {
  const [waNumber, setWaNumber] = useState('');
  const [step, setStep] = useState('input');
  const [sending, setSending] = useState(false);

  if (!isOpen) return null;

  const handleSend = async () => {
    setSending(true);
    setStep('preview');
    const res = await fetch(imageDataUrl);
    const blob = await res.blob();
    const file = new File([blob], 'HBD-Nof-Photobooth.png', { type: blob.type || 'image/png' });

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file], title: '🎂 Happy Birthday Nof!', text: 'Selamat Ulang Tahun, Nof! ❤️' });
        setStep('done'); setSending(false); return;
      } catch {}
    }

    const a = document.createElement('a');
    a.href = imageDataUrl; a.download = 'HBD-Nof-Photobooth.png'; a.click();
    const clean = waNumber.replace(/[^0-9]/g, '');
    const num = clean.startsWith('0') ? '62' + clean.slice(1) : clean;
    const msg = encodeURIComponent(`🎂 *Happy Birthday, Nof!* 🎉\n\nIni foto spesial hari ulang tahunmu! 💖\n\n_(Silakan kirim file foto yang baru didownload sebagai dokumen)_`);
    setTimeout(() => { window.open(num ? `https://wa.me/${num}?text=${msg}` : `https://wa.me/?text=${msg}`, '_blank'); setStep('done'); setSending(false); }, 600);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 300, background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(10px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ width: '100%', maxWidth: 440, background: 'var(--card)', border: '1px solid var(--border-warm)', borderRadius: 20, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.4)', transition: 'background 0.3s' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', background: 'var(--terra-dim)', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 28 }}>📲</span>
            <div>
              <h3 style={{ color: 'var(--text)', fontWeight: 700, fontSize: 16, margin: 0, fontFamily: "'DM Sans', sans-serif" }}>Kirim ke WhatsApp</h3>
              <p style={{ color: 'var(--text-faint)', fontSize: 12, margin: 0, fontFamily: "'DM Mono', monospace" }}>Foto Nof — HBD Edition</p>
            </div>
          </div>
          <button style={{ background: 'transparent', border: 'none', color: 'var(--text-faint)', fontSize: 16, cursor: 'pointer' }} onClick={onClose}>✕</button>
        </div>

        <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 16 }}>
          {step === 'input' && (
            <>
              <div style={{ borderRadius: 10, overflow: 'hidden', border: '1px solid var(--border)' }}>
                <img src={imageDataUrl} alt="Preview" style={{ width: '100%', maxHeight: 200, objectFit: 'cover', display: 'block' }} />
              </div>
              <div>
                <label style={{ display: 'block', color: 'var(--text-dim)', fontSize: 10, fontFamily: 'DM Mono, monospace', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 8 }}>
                  Nomor WhatsApp Nof
                </label>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '11px 14px' }}>
                  <span style={{ color: 'var(--text-faint)', fontFamily: 'DM Mono, monospace', fontSize: 13 }}>+</span>
                  <input type="tel" value={waNumber} onChange={e => setWaNumber(e.target.value)} placeholder="628xxxxxxxxx"
                    style={{ flex: 1, background: 'transparent', border: 'none', outline: 'none', color: 'var(--text)', fontFamily: 'DM Mono, monospace', fontSize: 13 }} />
                </div>
                <p style={{ color: 'var(--text-faint)', fontSize: 11, fontFamily: 'DM Mono, monospace', marginTop: 6 }}>
                  Kosongkan untuk buka WA tanpa nomor tertentu
                </p>
              </div>
              <button style={{ width: '100%', padding: '14px', background: '#25A049', border: 'none', borderRadius: 12, color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, fontFamily: "'DM Sans', sans-serif", boxShadow: '0 4px 20px rgba(37,160,73,0.25)' }}
                onClick={handleSend} disabled={sending}>
                <WaIco /> Kirim ke WhatsApp
              </button>
            </>
          )}

          {step === 'preview' && (
            <div style={{ textAlign: 'center', padding: '32px 0' }}>
              <div style={{ fontSize: 52, marginBottom: 16 }}>📲</div>
              <p style={{ color: 'var(--text)', fontWeight: 700, fontSize: 16, margin: '0 0 6px' }}>Memproses...</p>
              <p style={{ color: 'var(--text-dim)', fontSize: 13 }}>File sedang disiapkan</p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 14 }}>
                {[0, 1, 2].map(i => (
                  <div key={i} style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--terra)', animation: `pulse-dot 1.2s ${i * 0.2}s infinite` }} />
                ))}
              </div>
            </div>
          )}

          {step === 'done' && (
            <div style={{ textAlign: 'center', padding: '28px 0' }}>
              <div style={{ fontSize: 52, marginBottom: 14 }}>🎉</div>
              <p style={{ color: 'var(--text)', fontWeight: 700, fontSize: 17, margin: '0 0 8px', fontFamily: "'Playfair Display', serif" }}>Berhasil dikirim!</p>
              <p style={{ color: 'var(--text-dim)', fontSize: 13, marginBottom: 20 }}>Selamat Ulang Tahun, Nof! 💖</p>
              <button style={{ padding: '12px 32px', background: 'var(--terra-dim)', border: '1px solid var(--terra)', borderRadius: 12, color: 'var(--amber)', fontWeight: 600, fontSize: 14, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}
                onClick={onClose}>Selesai 🎂</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
